module.exports = __webpack_public_path__ + "img/图4.61ee5d06.png";